<template>
  <div style="width: 100%; height: 100%; display: flex; align-items: center; flex-direction: column; overflow: hidden;">
    <el-card shadow="never" class="search-card" style="width: 100%;">
      <el-form :model="form" label-position="left" label-width="60px" ref="searchFormRef" @submit.prevent @keyup.enter="search">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="6" :lg="6">
            <el-form-item label="账号" prop="account">
              <el-input clearable v-model="form.account" placeholder="搜索账号" style="width: 100%;" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6" :lg="6">
            <el-form-item label="名称" prop="name">
              <el-input clearable v-model="form.name" placeholder="搜索名称" style="width: 100%;" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6" :lg="6">
            <el-form-item label="状态" prop="status">
              <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%;">
                <el-option label="正常" value="1" />
                <el-option label="停用" value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="display: flex; align-items: center; justify-content: flex-end;">
            <el-form-item label=" " label-width="0">
              <div style="display: flex; gap: 8px;">
                <el-button type="primary" @click="search">查询</el-button>
                <el-button @click="reset">重置</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card shadow="never" class="table-card" style="width: 100%; flex: 1;">
      <template #header>
        <div class="table-header">
          <div class="table-header-left">
            <el-button v-if="$hasPermission('btn:add_account')" type="primary" @click="openAddDialog">
              <el-icon><Plus /></el-icon> 添加
            </el-button>
          </div>
          <div class="table-header-right">
            <el-tooltip content="刷新" placement="bottom"><el-button circle @click="loadData"><el-icon><Refresh /></el-icon></el-button></el-tooltip>
            <el-tooltip content="导出" placement="bottom"><el-button circle @click="handleExport"><el-icon><Download /></el-icon></el-button></el-tooltip>
            <el-tooltip content="打印" placement="bottom"><el-button circle @click="handlePrint"><el-icon><Printer /></el-icon></el-button></el-tooltip>
          </div>
        </div>
      </template>

      <el-table :data="tableData" border stripe :header-cell-style="stt" style="width: 100%">
        <el-table-column prop="account" label="账号" min-width="120" show-overflow-tooltip />
        <el-table-column prop="name" label="名称" min-width="120" show-overflow-tooltip />
        <el-table-column label="所属角色" min-width="140" show-overflow-tooltip>
          <template #default="{ row }">{{ getRoleName(row.role_id) }}</template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="100" align="center">
          <template #default="{ row }">
            <el-tag v-if="row.status == 1" type="success">正常</el-tag>
            <el-tag v-if="row.status == 0" type="danger">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" min-width="160" align="center">
          <template #default="{ row }">
            <el-button v-if="$hasPermission('btn:edit_account')" type="primary" size="small" plain @click.stop="edit(row)">编辑</el-button>
            <el-popconfirm v-if="$hasPermission('btn:delete_account')" confirm-button-text="删除" cancel-button-text="取消" title="确定删除吗?" @confirm="del(row)">
              <template #reference>
                <el-button type="danger" size="small" plain>删除</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrapper">
        <el-pagination
          @current-change="pageChange"
          @size-change="onSizeChange"
          v-model:current-page="page.current"
          v-model:page-size="page.pageSize"
          :total="page.total"
          background
          layout="total, sizes, prev, pager, next, jumper"
        />
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" v-model="dialogVisible" width="600px" @close="closeDialog" destroy-on-close>
      <el-form :rules="rules" :model="formEdit" label-width="auto" label-position="top" ref="editFormRef">
        <el-form-item label="头像" style="width: 100%">
          <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :on-success="(e) => { formEdit.avatar = e.data; }">
            <img v-if="formEdit.avatar" :src="$store.state.common.systemInfo.fileurl + formEdit.avatar" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"><el-icon><UploadFilled /></el-icon></i>
          </el-upload>
        </el-form-item>
        <el-form-item required label="用户账号" style="width: 100%" prop="account">
          <el-input v-model="formEdit.account" placeholder="请填写用户账号" />
        </el-form-item>
        <el-form-item required label="用户名称" style="width: 100%" prop="name">
          <el-input v-model="formEdit.name" placeholder="请填写用户名称" />
        </el-form-item>
        <el-form-item v-if="!editId" required label="登录密码" style="width: 100%" prop="password">
          <el-input v-model="formEdit.password" placeholder="请填写登录密码" />
        </el-form-item>
        <el-form-item label="手机号" style="width: 100%" prop="phone">
          <el-input v-model="formEdit.phone" placeholder="请输入手机号（选填，可用于快捷登录）" maxlength="11" clearable />
        </el-form-item>
		<!-- 企业：站点负责人和站点管理员都不允许改 -->
		<el-form-item label="所属企业" style="width: 100%" prop="enterprise_id">
		  <el-select v-model="formEdit.enterprise_id" placeholder="请选择企业" style="width: 100%;" @change="onEnterpriseChange" :disabled="!isSuperAdmin">
			<el-option v-for="item in enterpriseList" :key="item.id" :label="item.name" :value="item.id" />
		  </el-select>
		</el-form-item>

		<!-- 站点：只有站点负责人不能改。其他人只要选了企业就能改 -->
		<el-form-item label="所属站点" style="width: 100%" prop="station_id">
		  <el-select v-model="formEdit.station_id" placeholder="请先选择企业" style="width: 100%;" :disabled="!formEdit.enterprise_id || isStationLeader" @change="onStationChange">
			<el-option v-for="item in stationOptions" :key="item.id" :label="item.name" :value="item.id" />
		  </el-select>
		</el-form-item>
        <el-form-item label="角色" style="width: 100%">
          <el-select v-model="formEdit.role_id" placeholder="请选择角色" style="width: 100%;">
            <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="isSuperAdmin" label="佣金比例(%)" style="width: 100%" prop="commission_rate">
          <el-input-number v-model="formEdit.commission_rate" :min="0" :max="100" :precision="2" :step="0.1" controls-position="right" style="width: 100%" placeholder="请输入佣金比例（如0.3表示0.3%）" />
          <span style="font-size:12px;color:#999;">注：该值将更新到所选站点的佣金比例</span>
        </el-form-item>
        <el-form-item required label="账号状态" style="width: 100%">
          <el-select v-model="formEdit.status" placeholder="请选择状态" style="width: 100%;">
            <el-option label="正常" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="confirmEdit" :loading="submitting">确定</el-button>
      </template>
    </el-dialog>

    <ExportDialog
      v-model:visible="exportDialogVisible"
      :fields="exportFields"
      :export-api="exportApi"
      :get-search-params="getSearchParams"
      :current-page="page"
      default-file-name="用户数据"
    />
  </div>
</template>

<script>
import { pub } from '../../../common/event';
import { Plus, Refresh, Download, Printer } from '@element-plus/icons-vue';
import ExportDialog from '@/components/container/ExportDialog.vue';
import exportMixin from '@/mixins/exportMixin';
import { getUploadUrl } from '@/utils/upload';

export default {
  components: { Plus, Refresh, Download, Printer, ExportDialog },
  mixins: [exportMixin],
  data: () => ({
    form: {},
    formEdit: {},
    tableData: [],
    page: { current: 1, pageSize: 15, total: 15 },
    dialogVisible: false,
    editId: null,
    dialogTitle: '添加用户',
    submitting: false,
    roleList: [],
    enterpriseList: [],
    stationOptions: [],
    rules: {
      account: [{ required: true, message: '请输入用户账号', trigger: 'blur' }],
      name: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
      password: [{ required: true, message: '请输入登录密码', trigger: 'blur' }],
      enterprise_id: [{ required: true, message: '请选择所属企业', trigger: 'change' }],
      station_id: [{ required: false, message: '请选择所属站点', trigger: 'change' }],
      phone: [{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }],
    },
    exportFields: [
      { key: 'id', label: '序号列', checked: true },
      { key: 'account', label: '账号', checked: true },
      { key: 'name', label: '名称', checked: true },
      { key: 'phone', label: '手机号', checked: true },
      { key: 'role_name', label: '所属角色', checked: true },
      { key: 'status_label', label: '状态', checked: true },
      { key: 'enterprise_name', label: '所属企业', checked: true },
      { key: 'station_name', label: '所属站点', checked: true },
      { key: 'commission_rate', label: '佣金比例(%)', checked: true },
    ],
    stt: { background: '#209cd111', color: '#209cd1' },
  }),
  computed: {
    exportApi() { return this.$api.account.export; },
    isSuperAdmin() {
      const u1 = this.$store.state.user?.user;
      if (u1 && u1.role) return u1.role === 'super_admin';
      try {
        const u2 = JSON.parse(localStorage.getItem('user') || '{}');
        return u2.role === 'super_admin' || u2.role_id === 1;
      } catch (e) { return false; }
    },
	isAdmin() {
	  const u1 = this.$store.state.user?.user;
	  if (u1 && u1.role) return u1.role === 'admin';
	  try {
		const u2 = JSON.parse(localStorage.getItem('user') || '{}');
		return u2.role === 'admin';
	  } catch (e) { return false; }
	},
	isStationLeader() {
	  const u1 = this.$store.state.user?.user;
	  if (u1 && u1.role) return u1.role === 'station_leader';
	  try {
		const u2 = JSON.parse(localStorage.getItem('user') || '{}');
		return u2.role === 'station_leader';
	  } catch (e) { return false; }
	},
    uploadUrl() { return getUploadUrl('image'); },
  },
  mounted() {
    this.loadRoleList();
    this.loadEnterpriseList();
    this.loadData();
  },
  methods: {
	async loadRoleList() {
	  try {
		const ret = await this.$r.get(`account/account/role/list`);
		if (ret && ret.success) {
		  // 排除超级管理员（id=1），任何人都不能创建超管
		  let roles = (ret.data || []).filter((item) => item.id !== 1);
		  
		  const currentUser = this.$store.state.user.user || {};
		  const currentRole = currentUser.role;

		  if (currentRole === 'admin') {
			// 站点管理员：只能选站点负责人 (id=3)
			roles = roles.filter(item => item.id === 3);
		  } else if (currentRole === 'station_leader') {
			// 站点负责人：只能选普通会员 (id=4)
			roles = roles.filter(item => item.id === 4);
		  }

		  this.roleList = roles;
		}
	  } catch (e) { console.error('加载角色列表失败', e); }
	},
    async loadEnterpriseList() {
      try {
        const ret = await this.$api.enterprise.page({ status: 1, current: 1, pageSize: 999 });
        if (ret && ret.success) {
          this.enterpriseList = ret.data?.data || ret.data || [];
        }
      } catch (e) { console.error('加载企业列表失败', e); }
    },
    async loadStationList(enterpriseId) {
      if (!enterpriseId) {
        this.stationOptions = [];
        this.formEdit.station_id = null;
        return;
      }
      try {
        const ret = await this.$api.station.page({ enterpriseId, status: 1 });
        if (ret && ret.success) {
          this.stationOptions = ret.data?.data || ret.data || [];
        } else {
          this.stationOptions = [];
        }
      } catch (e) {
        console.error('加载站点列表失败', e);
        this.stationOptions = [];
      }
    },
    onEnterpriseChange(val) {
      this.formEdit.station_id = null;
      this.formEdit.commission_rate = null;
      this.loadStationList(val);
    },
    async onStationChange(stationId) {
      if (!stationId) {
        this.formEdit.commission_rate = null;
        return;
      }
      try {
        const ret = await this.$api.station.get(stationId);
        const data = ret?.data?.data || ret?.data?.record || ret?.data || {};
        if (this.isSuperAdmin) {
          const rate = data.commission_rate;
          this.formEdit.commission_rate =
            rate !== undefined && rate !== null && rate !== '' ? Number(rate) : null;
        }
      } catch (e) {
        console.error('加载站点佣金比例失败', e);
        if (this.isSuperAdmin) this.formEdit.commission_rate = null;
      }
    },
    filterWhere() {
      const whereform = { ...this.form };
      for (let k in whereform) {
        const v = whereform[k];
        if (v === null || v === undefined || v === '') delete whereform[k];
      }
      return { current: this.page.current, pageSize: this.page.pageSize, ...whereform };
    },
	getRoleName(roleId) {
	  if (roleId === null || roleId === undefined || roleId === '') return '-';
	  const found = this.roleList.find((item) => String(item.id) === String(roleId));
	  if (found) return found.name;
	  
	  // 如果下拉列表被过滤了，直接从死数据匹配
	  if (String(roleId) === '1') return '超级管理员'; 
	  if (String(roleId) === '2') return '站点管理员';
	  if (String(roleId) === '3') return '站点负责人';
	  if (String(roleId) === '4') return '普通会员';
	  
	  return '未知角色';
	},
    async loadData() {
      const where = this.filterWhere();
      const ret = await this.$api.account.page(where);
      if (ret && ret.success) {
        this.tableData = ret.data.data;
        this.page.total = ret.data.total;
        this.page.current = ret.data.page.current;
        this.page.pageSize = ret.data.page.pageSize;
      }
    },
	
	openAddDialog() {
	  this.editId = null;
	  this.dialogTitle = '添加用户';
	  
	  const currentUser = this.$store.state.user.user || {};
	  const defaultEnterpriseId = this.isSuperAdmin ? null : (currentUser.enterpriseId || currentUser.enterprise_id);
	  const defaultStationId = this.isStationLeader ? (currentUser.stationId || currentUser.station_id) : null;
	  const defaultRoleId = this.roleList.length === 1 ? this.roleList[0].id : null;

	  this.formEdit = {
		account: '', name: '', password: '', phone: '',
		status: 1, avatar: '', role_id: defaultRoleId,
		enterprise_id: defaultEnterpriseId,
		station_id: defaultStationId,
		// ★ 核心修复：默认给 0.30
		commission_rate: 0.30, 
	  };
	  
	  if (this.formEdit.enterprise_id) {
		this.loadStationList(this.formEdit.enterprise_id).then(() => {
		  if (this.isStationLeader && defaultStationId) {
			this.onStationChange(defaultStationId);
		  }
		});
	  } else {
		this.stationOptions = [];
	  }
	  
	  this.dialogVisible = true;
	  this.$nextTick(() => { this.$refs.editFormRef?.clearValidate(); });
	},
	
    edit(row) {
      this.editId = row.id;
      this.dialogTitle = '编辑用户';
      // ★ 防止老数据是 0 或空，强制展示 0.3
	  let rate = row.commission_rate;
	  if (rate === null || rate === undefined || rate === '' || Number(rate) === 0) {
	    rate = 0.30;
	  }
	    
	  this.formEdit = {
	    ...row,
	    password: '',
	    phone: row.phone || '',
	    role_id: row.role_id || null,
	    enterprise_id: row.enterprise_id || null,
	    station_id: row.station_id || null,
	    commission_rate: rate, // 使用兜底后的值
	  };
      if (this.formEdit.enterprise_id) {
        this.loadStationList(this.formEdit.enterprise_id).then(() => {
          if (this.isSuperAdmin && this.formEdit.station_id) this.onStationChange(this.formEdit.station_id);
        });
      } else {
        this.stationOptions = [];
      }
      this.dialogVisible = true;
      this.$nextTick(() => { this.$refs.editFormRef?.clearValidate(); });
    },
    closeDialog() {
      this.dialogVisible = false;
      this.editId = null;
      this.formEdit = {
        account: '', name: '', password: '', phone: '',
        status: 1, avatar: '', role_id: null,
        enterprise_id: null, station_id: null, commission_rate: null,
      };
      this.stationOptions = [];
    },
    async confirmEdit() {
      if (this.isSuperAdmin && this.formEdit.station_id &&
          (this.formEdit.commission_rate === null || this.formEdit.commission_rate === undefined)) {
        pub('error_message', '已选站点时必须填写佣金比例');
        return;
      }
      try { await this.$refs.editFormRef.validate(); } catch (e) { return; }

      this.submitting = true;
      try {
        const data = { ...this.formEdit };
        if (data.password === '') delete data.password;
        if (!this.isSuperAdmin) delete data.commission_rate;
        
        if (data.phone === '') {
          data.phone = null;
        }

        let ret;
        if (this.editId) {
          data.id = this.editId;
          ret = await this.$api.account.put(data);
        } else {
          ret = await this.$api.account.post(data);
        }
        if (ret && ret.success) {
          if (ret.data && ret.data._warning) {
            pub('warning_message', '账号保存成功，但' + ret.data._warning);
          } else {
            pub('success_message', this.editId ? '编辑成功' : '添加成功');
          }
          this.closeDialog();
          this.loadData();
        } else {
          pub('error_message', ret?.message || '操作失败');
        }
      } catch (e) {
        console.error('提交失败:', e);
        pub('error_message', '请求失败');
      } finally {
        this.submitting = false;
      }
    },
    async del(row) {
      const ret = await this.$api.account.del(row.id);
      if (ret && ret.success) {
        pub('success_message', '删除成功');
        this.loadData();
      } else {
        pub('error_message', ret?.message || '删除失败');
      }
    },
    pageChange(e) { this.page.current = e; this.loadData(); },
    onSizeChange() { this.page.current = 1; this.loadData(); },
    reset() {
      this.form = {};
      this.$refs.searchFormRef?.resetFields();
      this.loadData();
    },
    search() { this.page.current = 1; this.loadData(); },
    handleExport() { this.openExportDialog(); },
    handlePrint() { window.print(); },
  },
};
</script>

<style scoped>
.search-card { margin-bottom: 16px; }
.search-card .el-form-item { margin-bottom: 0; }
.table-card :deep(.el-card__header) { padding: 10px 16px; border-bottom: 1px solid #e4e7ed; }
.table-header { display: flex; justify-content: space-between; align-items: center; width: 100%; }
.table-header-left { display: flex; align-items: center; gap: 8px; }
.table-header-right { display: flex; align-items: center; gap: 4px; }
.pagination-wrapper { display: flex; justify-content: center; margin-top: 16px; }
.avatar-uploader .el-upload { border: 1px dashed #d9d9d9; border-radius: 6px; cursor: pointer; position: relative; overflow: hidden; width: 80px; height: 80px; }
.avatar-uploader .el-upload:hover { border-color: #409EFF; }
.avatar-uploader-icon { font-size: 28px; color: #8c939d; width: 80px; height: 80px; line-height: 80px; text-align: center; }
.avatar { width: 80px; height: 80px; display: block; }
</style>